import { makeStyles, Typography } from "@material-ui/core"
import clsx from "clsx"
import { FC, useState } from "react"
import { useRecoilState } from "recoil"
import { useNavigation } from "../../hooks/useNavigation"
import { useApi } from "../../utils/API"
import { isErrorResponse } from "../../utils/helpers"
import { forgotPasswordEmailState } from "../../utils/store"
import { colors } from "../../utils/theme"
import Logo from "../atoms/Logo"
import { GhostButton, PrimaryButton } from "../atoms/button/Button"
import Input from "../atoms/input/Input"
import { TitledCard } from "../molecules/titledCard/TitledCard"
import { BaseTemplate } from "../templates/BaseTemplate"

const useStyles = makeStyles((theme) => ({
  logo: {
    position: "absolute",
    top: theme.spacing(6),
    left: theme.spacing(6),
  },
  center: {
    display: "flex",
    alignItems: "center",
    alignSelf: "center",
  },
  button: {
    width: "100%",
  },
  marginBottom32: {
    marginBottom: theme.spacing(4),
  },
  marginBottom24: {
    marginBottom: theme.spacing(3),
  },
  marginBottom16: {
    marginBottom: theme.spacing(2),
  },
  marginBottom8: {
    marginBottom: theme.spacing(1),
  },
  asphalt: {
    color: colors.neutral.asphalt,
  },
  denim: {
    color: colors.neutral.denim,
  },
  bottomText: {
    color: colors.neutral.asphalt,
    marginRight: 4,
  },
}))

const ForgotPassword: FC = () => {
  const classes = useStyles()
  const { requestPasswordReset } = useApi()
  const [email, setEmail] = useRecoilState(forgotPasswordEmailState)
  const [emailError, setEmailError] = useState<boolean>(false)
  const { toLogin, toForgotPasswordSuccess } = useNavigation()

  return (
    <BaseTemplate>
      <Logo className={classes.logo} />
      <TitledCard title="Forgot Password">
        <Typography
          variant="body1"
          className={clsx(classes.marginBottom32, classes.denim)}
        >
          A link to reset your password will be sent to your email address.
        </Typography>
        <Input
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          error={emailError}
          className={classes.marginBottom24}
          label="Email"
          placeholder="Email"
        />
        <div className={classes.marginBottom16}>
          <PrimaryButton
            className={classes.button}
            onClick={async () => {
              setEmailError(false)
              if (!email) {
                setEmailError(true)
                return
              }
              const response = await requestPasswordReset(email)
              if (isErrorResponse(response.data)) {
                setEmailError(true)
                return
              }
              toForgotPasswordSuccess()
            }}
          >
            Submit
          </PrimaryButton>
        </div>
        <div className={clsx(classes.center, classes.marginBottom8)}>
          <Typography variant="h6" className={classes.bottomText}>
            Return to
          </Typography>
          <GhostButton onClick={toLogin}>Log In</GhostButton>
        </div>
      </TitledCard>
    </BaseTemplate>
  )
}

export default ForgotPassword
